<div [style.background]="backgroundHexColor">
    <span>{{ text }}</span>
</div>